import { Breakpoints, styled } from '@vw-marketing/us-components';

export const MlpSkeletonWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      align-items: center;
      background: ${theme.colors.gradient.top};
      color: white;
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static400};
      height: auto;
      max-width: 1600px;
      padding: ${theme.size.dynamic0150} 20px;
      width: 100vw;

      @media (min-width: ${Breakpoints.b960}px) {
        align-items: flex-start;
        flex-direction: row;
        gap: 40px;
        justify-content: center;
        padding: ${theme.size.dynamic0130} 40px;
      }

      @media (min-width: ${Breakpoints.b1280}px) {
        gap: 67px;
        padding: ${theme.size.dynamic0130} 53px;
        width: 100%;
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        padding: ${theme.size.dynamic0130} 67px;
      }
    `;
  }}
`;

export const SyledLogoWrapper: any = styled.div`
`;

export const StyledBoxeswrapper: any = styled.div`
  @media (max-width: ${Breakpoints.b960}px) {
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.size.static400};
  }
`;


